import { render, staticRenderFns } from "./VDialogWrapper.vue?vue&type=template&id=f3d6ebf2"
import script from "./VDialogWrapper.vue?vue&type=script&lang=js"
export * from "./VDialogWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports